export default __webpack_public_path__ + "static/media/hiking.f391408a.jpeg";